export default __webpack_public_path__ + "static/media/slider-cai-2.8131470e.jpg";